/**
 * @generated SignedSource<<7007d9cb87d610edb401c4e4b129bd20>>
 * @relayHash 195ffcc5de20ac50803d32f61d5bb847
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 12feb6386337a9e52ff29357aa49b7c0c19993ec01031867fd8f26dee930e579

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type RoadmapResolveHealthcheckInput = {
  actionId: string;
  addLevelOneIssueType?: RoadmapAddLevelOneIssueTypeHealthcheckResolution | null | undefined;
};
export type RoadmapAddLevelOneIssueTypeHealthcheckResolution = {
  create?: RoadmapCreateLevelOneIssueType | null | undefined;
  promote?: RoadmapPromoteLevelOneIssueType | null | undefined;
};
export type RoadmapCreateLevelOneIssueType = {
  epicTypeDescription: string;
  epicTypeName: string;
};
export type RoadmapPromoteLevelOneIssueType = {
  promoteItemTypeId: string;
};
export type resolveHealthcheckMutation$variables = {
  input: RoadmapResolveHealthcheckInput;
  sourceARI: string;
};
export type resolveHealthcheckMutation$data = {
  readonly roadmaps: {
    readonly resolveRoadmapHealthcheck: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly errorType?: string | null | undefined;
          readonly statusCode?: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type resolveHealthcheckMutation = {
  response: resolveHealthcheckMutation$data;
  variables: resolveHealthcheckMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceARI"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  },
  {
    "kind": "Variable",
    "name": "sourceARI",
    "variableName": "sourceARI"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "statusCode"
    },
    {
      "kind": "ScalarField",
      "name": "errorType"
    }
  ],
  "type": "RoadmapMutationErrorExtension"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "resolveHealthcheckMutation",
    "selections": [
      {
        "concreteType": "RoadmapsMutation",
        "kind": "LinkedField",
        "name": "roadmaps",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "RoadmapResolveHealthcheckPayload",
            "kind": "LinkedField",
            "name": "resolveRoadmapHealthcheck",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "resolveHealthcheckMutation",
    "selections": [
      {
        "concreteType": "RoadmapsMutation",
        "kind": "LinkedField",
        "name": "roadmaps",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "RoadmapResolveHealthcheckPayload",
            "kind": "LinkedField",
            "name": "resolveRoadmapHealthcheck",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "12feb6386337a9e52ff29357aa49b7c0c19993ec01031867fd8f26dee930e579",
    "metadata": {},
    "name": "resolveHealthcheckMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7937429ceae92519546484200a3f3d14";

export default node;
